import type { GlobalMarketPrice } from '@/entities/global-market/types';

/**
 * TRAD-2086 — 트랙 콘텐츠 폭이 뷰포트보다 좁으면 -100%/N 루프 지점에서 빈 공간이 노출된다.
 * 항목이 적을수록(콘텐츠 한 벌의 폭이 좁을수록) 복제 횟수를 늘려 항상 뷰포트를 채우도록 한다.
 * 화면마다 실제 폭이 달라 정확한 실측 대신, 넉넉한 계단식 휴리스틱으로 안전마진을 확보한다
 * (기법 자체를 갈아엎지 않고 기존 "콘텐츠 ×N + -100%/N" 방식 그대로 유지).
 */
export const getTickerCopyCount = (itemCount: number): number => {
  if (itemCount <= 0) return 2;
  if (itemCount <= 4) return 6;
  if (itemCount <= 8) return 4;
  if (itemCount <= 14) return 3;
  return 2;
};

/**
 * TRAD-2086 — 카테고리(지수/원자재) 그룹핑은 유지하되 그룹 내부는 symbol 오름차순으로 고정 정렬.
 * 백엔드가 배열 순서를 보장하지 않아도(또는 refetch마다 순서가 흔들려도) 항상 같은 순서로 렌더해
 * 항목 재배치로 인한 시각적 흔들림을 막는다.
 */
export const sortMarketPricesBySymbol = (items: GlobalMarketPrice[]): GlobalMarketPrice[] =>
  [...items].sort((a, b) => a.symbol.localeCompare(b.symbol));
